import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toPersianNum } from "../../assets/utils";
import ToIcon from "../../assets/img/icn_to_blk.svg";
import {
  ReceiverContStyled,
  Destenitions,
  FullAdress,
  ReceiverInfoStyled,
  BtnContainer,
  R,
  BtnStyled,
  BlureText,
  BoldText,
} from "./receiverInfo.styles";
import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";
const ReceiverInfo = () => {
  const ReceiverInfoData = useSelector(selectCurrentReqInfo);
  console.log("majid", ReceiverInfoData);
  const { detail, _ostan, _shahr } = ReceiverInfoData.destination_location;
  const { phone, name } = ReceiverInfoData.deliver_to;
  return (
    <ReceiverContStyled>
      <Destenitions>
        <img src={ToIcon} alt="icn" />
        <BoldText>مقصد ۱:</BoldText>
        <BoldText>{_shahr.shahrname}</BoldText>
        <BlureText>{_ostan.provincename}</BlureText>
      </Destenitions>
      <FullAdress>{detail}</FullAdress>
      <ReceiverInfoStyled>
        <R>{name}</R>
        <R>{toPersianNum(phone)}</R>
      </ReceiverInfoStyled>
      <BtnContainer>
        <BtnStyled>ویرایش</BtnStyled>
      </BtnContainer>
    </ReceiverContStyled>
  );
};

export default ReceiverInfo;
